import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.active';

@Injectable({
  providedIn: 'root',
})
export class PoliciesService {
  private readonly urlPath = 'policies';

  constructor(private httpClient: HttpClient) {}

  exportPolicyPdf(id: string): any {
    return this.httpClient
      .get(
        `${environment.apiUrl}${this.urlPath}/export-policy-pdf/${id}`,
        {
          responseType: 'blob',
        },
      )
      .pipe();
  }
  exportProcedurePdf(id: string): any {
    return this.httpClient
      .get(
        `${environment.apiUrl}${this.urlPath}/export-procedure-pdf/${id}`,
        {
          responseType: 'blob',
        },
      )
      .pipe();
  }
  getPolicies(): any {
    return this.httpClient
      .get(
        `${environment.apiUrl}${this.urlPath}/get-all-files-and-folders`
      )
      .pipe();
  }
  getPoliciesConfigurations(): any {
    return this.httpClient
      .get(
        `${environment.apiUrl}${this.urlPath}/get-policies-configurations`
      )
      .pipe();
  }
}
